module.exports = __webpack_public_path__ + "img/header-video.d95c3695.jpg";